import React from 'react';
import './CombatDecisionPrompt.scss';
import { Button, Modal } from 'react-bootstrap';

/** Shared presentation only; callers retain ownership of all rules and effects. */
export default function CombatDecisionPrompt({
  show = false, title, children, primaryLabel, secondaryLabel,
  onPrimary, onSecondary, resolving = false, error = '',
}) {
  return (
    <Modal className="dnd-modal combat-decision-prompt" centered show={show} onHide={() => {}}
      backdrop="static" keyboard={false}>
      <Modal.Header><Modal.Title>{title}</Modal.Title></Modal.Header>
      <Modal.Body>
        {children}
        {error && <div className="text-danger mt-3" role="alert">{error}</div>}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" disabled={resolving} onClick={onSecondary}>{secondaryLabel}</Button>
        <Button disabled={resolving} onClick={onPrimary}>{primaryLabel}</Button>
      </Modal.Footer>
    </Modal>
  );
}
